export default {
  nicheCategories: []
}
